export default __webpack_public_path__ + "static/media/private-label_wide.ab845153.jpg";